import { Swiper, SwiperSlide } from "swiper/react"; // Import Swiper React components
import "./styles.scss";
import clsx from "clsx";
import SwiperItem from "./SwiperItem";
import "swiper/css/effect-fade";
import { useRef } from "react";
import { EffectFade, Autoplay, Navigation } from "swiper";
// import arrowLeft from "../../images/left-arrow.svg";
// import arrowRight from "../../images/right-arrow.svg";
import "swiper/css"; // Import Swiper styles
import "swiper/css/navigation";

const MainSwiper = (props) => {
  const { swiperItems } = props;
  const swiperRef = useRef(null);
  const shouldRenderItems = !!swiperItems;

  return (
    shouldRenderItems && (
      <div className="mainSwiper">
        <div className="comp-wrap full-width">
          <div className="comp-cont">
            <Swiper
              ref={swiperRef}
              modules={[EffectFade, Autoplay, Navigation]}
              autoplay={{
                delay: 5000,
                disableOnInteraction: false,
              }}
              effect="fade"
              className={clsx("main-swiper-global")}
              spaceBetween={0}
              slidesPerView={1}
              loop={true}
              preventClicks={true}
              preventClicksPropagation={true}
              navigation={true}
            >
              {swiperItems?.map((item, index) => {
                return (
                  <SwiperSlide
                    key={index}
                    style={{ background: item?.background }}
                    className={clsx(item?.isContain ? "isContain" : "")}
                  >
                    <SwiperItem item={item} />
                  </SwiperSlide>
                );
              })}
            </Swiper>
          </div>
        </div>
        {/* <div className="swiper-arrow arrow-left">
          <img src={arrowLeft} />
        </div>
        <div className="swiper-arrow arrow-right">
          <img src={arrowRight} />
        </div> */}
      </div>
    )
  );
};
export default MainSwiper;
